export default __webpack_public_path__ + "static/media/News-icon.ca94d8c4.svg";